// Import the styled-components library
import styled from 'styled-components';

export const CenteredParagraph = styled.p`
  text-align: center;
  width: 100%;
`;
